<template>
  <v-dialog v-model="dialog" width="1100px" :fullscreen="$vuetify.breakpoint.smAndDown" scrollable>
    <v-card>
      <v-card-title class="primary white--text">
        <v-toolbar-title>Xem chi tiết</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-card-text :class="{ 'doc-type': !isPdf }">
        <div v-if="isPdf">
          <pdf v-for="i in numPages" :key="i" :src="fileUrl" :page="i" style="width: 100%" />
        </div>
        <div v-else-if="customType" style="height: 700px">
          <CustomOfficeViewer :value="fileUrl" />
        </div>
        <VueDocPreview type="office" :value="fileUrl" v-else />
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="d-flex justify-space-between pa-4">
        <v-btn class="px-6" outlined light depressed @click="openLink">Tải xuống</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" width="100px" class="elevation-0" @click="cancel">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import pdf from 'vue-pdf'
import VueDocPreview from 'vue-doc-preview'
import CustomOfficeViewer from './CustomOfficeViewer.vue'
import { get } from 'lodash'

const getFileUrl = (file = {}) => {
  let fileUrl = ''
  if (get(file, 'url')) fileUrl = get(file, 'url')
  else
    fileUrl = `https://lms-ltv-bucket2.s3.ap-southeast-1.amazonaws.com/${get(file, 'hash')}${get(
      file,
      'ext',
    )}?t=${Date.now()}`
  return fileUrl
}

export default {
  components: { pdf, VueDocPreview, CustomOfficeViewer },
  props: { state: { type: Boolean, default: false }, file: { type: Object, default: () => {} }, customType: Boolean },
  data() {
    return {
      dialog: false,
      numPages: 0,
      isPdf: false,
    }
  },
  computed: {
    fileUrl() {
      return getFileUrl(this.file)
    },
  },

  methods: {
    cancel() {
      this.dialog = false
    },
    openLink() {
      const url = this.fileUrl
      if (typeof url === 'string' && url.length) window.open(url, '_blank')
      else this.$alert.error('Link file không tồn tại!')
    },
  },
  watch: {
    async state() {
      this.dialog = true
      if (this.file && this.file.name) {
        this.$loading.active = true
        this.isPdf = false

        if (this.file.name.endsWith('.pdf')) {
          this.isPdf = true
          const url = getFileUrl(this.file)
          const f = await pdf.createLoadingTask(url).promise
          this.numPages = f.numPages
        }

        this.$loading.active = false
      }
    },
  },
}
</script>
<style scoped>
.doc-type {
  overflow: hidden !important;
}
</style>
